'use client';

import { SignedIn, SignedOut, SignUpButton } from '@clerk/nextjs';
import Link from 'next/link';
import { Button } from '../../../ui/button';
import { UserButton } from '../../User/UserButtonAndMenu';
import { usePathname } from 'next/navigation';
import useHosting from '@/hooks/useHosting';
import { Logo } from './Logo';
import SignedOutMobileLinks from './SignedOutMobileLinks';
import SignedOutDesktopLinks from './SignedOutDesktopLinks';
import { useScroll } from '../../Utilities/useScroll';

export default function Navbar() {
  const pathname = usePathname();
  const { isHosting, setIsHosting } = useHosting();

  const hasScroll = useScroll();
  const isHomePage =
    pathname === '/' ||
    pathname === '/about' ||
    pathname === '/hosting' ||
    pathname.startsWith('/campaigns');

  const textColor = hasScroll || !isHomePage ? 'black' : 'white';

  const otherPagesBackground = 'bg-gradient-to-r from-secondary via-brand-blue to-accent shadow-md';
  const stickyHomePage = 'bg-transparent';

  return (
    <header
      className={`top-0 w-full z-50 transition-all duration-200 px-2 py-4 top-0 ${isHomePage ? 'fixed' : 'relative'} ${
        hasScroll
          ? isHomePage
            ? otherPagesBackground
            : otherPagesBackground
          : isHomePage
            ? stickyHomePage
            : otherPagesBackground
      }`}
    >
      <div className="max-w-screen-2xl w-full mx-auto flex md:gap-4 justify-between items-center">
        <Link href="/" className="flex-shrink-0 mr-10">
          <Logo color={isHomePage ? textColor : 'black'} />
        </Link>

        <SignedIn>
          <div className="flex w-full justify-end items-center gap-2">
            <UserButton
              color={textColor}
              variant="default"
              isHosting={isHosting}
              onRoleChange={setIsHosting}
            />
          </div>
        </SignedIn>

        <SignedOut>
          <div className="flex flex-shrink-0 items-center ">
            {pathname === '/hosting' ? (
              <SignUpButton forceRedirectUrl={'/host'}>
                <Button variant={'secondary'}>List Your Property</Button>
              </SignUpButton>
            ) : (
              <>
                {/* Show only on desktop */}
                <div className="hidden sm:block">
                  <SignedOutDesktopLinks color={textColor} />
                </div>

                {/* Show only on mobile */}
                <div className="sm:hidden">
                  <SignedOutMobileLinks color={textColor} />
                </div>
              </>
            )}
          </div>
        </SignedOut>
      </div>
    </header>
  );
}
